module.exports = __webpack_public_path__ + "img/Hematology Reagents Kit.2 (mid).c0d0bbeb.jpg";